'use client'

import { useState } from "react"

type ProtectedProps = {
    text: string
}

export default function Protected({
    text
}: ProtectedProps) {

    const [isProtected, setProtected] = useState(true)

    return (
        <>
            {isProtected ?
                <>
                    <span onMouseEnter={() => setProtected(false)} onClick={() => setProtected(false)}>{text.replace(/^(.{2})(.*)/, (match, p1, p2) => p1 + p2.replace(/[^ ]/g, '*'))}</span>
                </>
                :
                <>
                    {text}
                </>
            }
        </>
    )

}